// PR-28: tiny hook that mirrors `navigator.onLine` and stays in sync via
// the browser's `online`/`offline` events.
//
// Caveats: `navigator.onLine === false` only when the OS reports no
// connectivity (airplane mode, no wifi). A flaky cellular connection can
// still report online while requests fail — for those cases we ALSO
// queue on a network-shaped fetch failure (see MobileCapture). Belt-and-
// suspenders.

import { useEffect, useState } from 'react'

export interface NetworkStatus {
  online: boolean
}

export function useNetworkStatus(): NetworkStatus {
  const [online, setOnline] = useState<boolean>(() =>
    typeof navigator !== 'undefined' ? navigator.onLine : true,
  )

  useEffect(() => {
    if (typeof window === 'undefined') return
    const onOn = () => setOnline(true)
    const onOff = () => setOnline(false)
    window.addEventListener('online', onOn)
    window.addEventListener('offline', onOff)
    return () => {
      window.removeEventListener('online', onOn)
      window.removeEventListener('offline', onOff)
    }
  }, [])

  return { online }
}
